module.exports = __webpack_public_path__ + "b6c45829b80011f2626783b9422d587d.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_analytics/icons/screenshots.png
// module id = 1266
// module chunks = 69